/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportGenerationStatusResponseDTO { 
    externalId?: string;
    email?: string;
    serialId?: string;
    geaPUID?: string;
    status?: ReportGenerationStatusResponseDTO.StatusEnum;
    reportId?: string;
    timezone?: string;
}
export namespace ReportGenerationStatusResponseDTO {
    export const StatusEnum = {
        Pending: 'PENDING',
        Failed: 'FAILED',
        Completed: 'COMPLETED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


